import { Button, Modal, ModalBody, ModalContent, ModalFooter } from "@heroui/react";
import { CircleXIcon } from "lucide-react";
import type { ManualClaimTxFail } from "../../state/types";
import { formatTimestamp } from "../../utils";
import { TxHashLink } from "../TxHashLink";

export function ManualClaimFailModal({
  isOpen,
  onClose,
  onRetry,
  claimTx,
}: {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
  claimTx: ManualClaimTxFail;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody>
          <CircleXIcon className="size-24 stroke-1 text-red-500/90 fill-red-500/10 " />
          <p className="font-semibold text-large">Manual claim failed!</p>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex items-center justify-between w-full">
              <div className="text-[#ADC0D0]">Date & time</div>
              <div className="font-semibold">{formatTimestamp(claimTx.claimTimestamp)}</div>
            </div>

            <div className="flex items-center justify-between w-full">
              <div className="text-[#ADC0D0]">Transaction Hash</div>
              <div className="font-semibold">
                <TxHashLink
                  txHash={"0x" /* TODO: display claimTxHash - needs refactoring */}
                  source={claimTx.bridgeType === "deposit" ? "l2" : "l1"}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button fullWidth variant="bordered" color="primary" size="lg" radius="full" onPress={onClose}>
            Close
          </Button>
          <Button fullWidth color="primary" size="lg" radius="full" onPress={onRetry}>
            Try Again
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
